import signInForm from './sign-in-form/template'
import phoneNumberField from './phone-number-field/template'
import siteAlertsTray from './site-alerts-tray/template'
import mobileMoneyAccountSelector from './mobile-money-account-selector/template'
import stQrcodeStream from './st-qrcode-stream/template'
import verifyPassengerAccess from './verify-passenger-access/template'
import manageMobileMoneyAccounts from './manage-mobile-money-accounts/template'
import stUploader from './st-uploader/template'
import stCalendar from './st-calendar/template'
import searchRouteFare from './search-route-fare/template'
import busStopSelector from './bus-stop-selector/template'
import { currencyField, pendingLoader, stDateField, stVideoSnapshot } from '@smarttransit/common-client'
import { stMap } from '@smarttransit/common-map'

export default {
  'currency-field': currencyField,
  'phone-number-field': phoneNumberField,
  'sign-in-form': signInForm,
  'site-alerts-tray': siteAlertsTray,
  'mobile-money-account-selector': mobileMoneyAccountSelector,
  'verify-passenger-access': verifyPassengerAccess,
  'manage-mobile-money-accounts': manageMobileMoneyAccounts,
  'search-route-fare': searchRouteFare,
  'bus-stop-selector': busStopSelector,
  'st-qrcode-stream': stQrcodeStream,
  'st-uploader': stUploader,
  'st-calendar': stCalendar,
  'st-date-field': stDateField,
  'st-map': stMap,
  'st-pending-loader': pendingLoader,
  'st-video-snapshot': stVideoSnapshot
}
